export const CLOCK_INTERVAL = 250
export const THUMB_WIDTH = 10
